import React from 'react';
import { classes } from 'typestyle';

import { PageHeaderButtonType } from '~src/spacesPlatform/components/layout/PageHeader';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

import { telemetryConsumerWrapper } from '../../../../app/contexts/TelemetryConsumerWrapper';
import { FavoriteToggleClickedTelemetryContext } from '../../../../app/contexts/TelemetryContexts';
import { Messages } from '../../../../codegen/Localize';
import {
  FavoriteToggleClickedEventHandler,
  FavoriteToggleType
} from '../../../telemetryEvents/types/ContentTelemetryTypes';

export class FavoriteToggle extends React.PureComponent<FavoriteToggle.Props, FavoriteToggle.State> {

  static displayName = 'FavoriteToggle';

  static element = React.createFactory(FavoriteToggle);

  constructor(props: FavoriteToggle.Props){
    super (props);
    this.state = { isFavorite: this.props.isFavorite };
  }

  //TODO: componentWillReceiveProps is deprecated. Either the toggle should not manage its own state or its state should
  // not depend on its props.
  // See: https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html
  public componentWillReceiveProps(nextProps: FavoriteToggle.Props){
    this.setState({ isFavorite: nextProps.isFavorite });
  }

  public render() {
    return telemetryConsumerWrapper(FavoriteToggleClickedTelemetryContext.Consumer, this.renderFavoriteToggle);
  }

  private renderFavoriteToggle = (sendFavoriteToggleClickTelemetry: FavoriteToggleClickedEventHandler) => {
    // default button type is regular
    const buttonClasses = classes(
      this.props.buttonType === 'light' ? 'tb-favorite-button-light' : 'tb-favorite-button',
      this.state.isFavorite && 'tb-selected',
      PageHeaderStyles.FavoriteButtonFocusClass,
    );

    const { isFavorite, onAddFavorite, onRemoveFavorite, isTabbable, hideHelpTooltip, buttonType, ...domAttrs } = this.props;

    return (
      <span
        className={buttonClasses}
        tabIndex={this.props.isTabbable ? 0 : -1}
        onClick={(event: React.SyntheticEvent<HTMLSpanElement>) => {
          const toggleType = this.state.isFavorite ? FavoriteToggleType.Unfavorite : FavoriteToggleType.Favorite;
          sendFavoriteToggleClickTelemetry(toggleType);
          this.boundHandleClick(event);
        }}
        onKeyDown={this.boundHandleKeypress}
        title={this.getTitleIfApplicable()}
        role={'button'}
        aria-pressed={this.state.isFavorite}
        {...domAttrs}
      />
    );
  }

  private boundHandleClick = (event: React.SyntheticEvent<HTMLSpanElement>) => {
    this.state.isFavorite ? this.props.onRemoveFavorite() : this.props.onAddFavorite();
    this.setState({ isFavorite: !this.state.isFavorite });
    event.preventDefault();
    event.stopPropagation();
  }

  private boundHandleKeypress = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      this.boundHandleClick(event);
    }
  }

  private getTitleIfApplicable() {
    if (this.props.hideHelpTooltip) {
      return undefined;
    }

    return this.props.isFavorite? Messages.favoritesTitleNotFavorited() : Messages.favoritesTitleFavorited();
  }

}

export namespace FavoriteToggle {

  export interface Props {
    isFavorite: boolean;
    onAddFavorite: () => void;
    onRemoveFavorite: () => void;
    isTabbable: boolean;
    hideHelpTooltip?: boolean;
    buttonType?: PageHeaderButtonType;
  }

  export interface State {
    isFavorite: boolean;
  }

}
